import styled from "styled-components";
import { PRIMARY_COLOR } from "../../../utils/const";

export const HubContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  align-items: center;
  background-color: #fff;
  text-align: center;
  padding: 20px 0;

  background-image: url("https://icons-greendragon.s3.us-east-2.amazonaws.com/other/neurona-gris.png");
  background-repeat: no-repeat;
  background-size: 35%;
  background-position: center;
  height: 600px;
`;

export const HubWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(25rem, 1fr));
  grid-auto-rows: 30rem;
  align-items: center;
  gap: 3rem;
`;

export const HubCard = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  height: 300px;
  max-height: 340px;
  padding: 30px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
  box-shadow: 5px 3px 6px #00000066;

  &:hover {
    transform: scale(1.05);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }

  @media (max-width: 350px) {
    width: 200px;
  }
`;

export const HubIcon = styled.img`
  height: 160px;
  width: 160px;
  margin-bottom: 10px;
`;

export const HubH1 = styled.h1`
  font-size: 3rem;
  font-weight: 600;
  color: ${PRIMARY_COLOR};
  margin-bottom: 64px;

  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const HubH2 = styled.h2`
  font-size: 1.6rem;
  margin-bottom: 10px;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const HubP = styled.p`
  font-size: 1.5rem;
  text-align: center;
`;

export const UserContainer = styled.div`
  justify-content: center;
  background-color: #fff;
  margin-top: 70px;
  /* padding-top: 40px; */
  /* margin-left: 80px; */
  /* margin-right: 80px; */
`;

export const UserH1 = styled.h1`
  margin-bottom: 2px;
  font-size: 3rem;
  font-weight: 500;
  color: #010606;
`;

export const UserH2 = styled.text`
  font-size: 2rem;
  color: #010606;
  margin-bottom: 15px;
`;

export const UserH2Flex = styled.text`
  font-size: 2rem;
  color: #010606;
  margin-bottom: 15px;
  justify-content: flex-start;
`;

export const Img = styled.img`
  width: 160px;
  height: auto;
  margin: 0;
  padding: 0;
  @media screen and (max-width: 960px) {
    width: 150px;
  }
  @media screen and (max-width: 768px) {
    width: 140px;
  }
`;
